import {
  RESET_MY_ORDERS,
  MY_ORDERS_NOT_FOUND,
  MY_ORDERS_FAILED,
  MY_ORDERS_INVALID_REQUEST,
  MY_ORDERS_SUCCESS,
  LOADING_MY_ORDERS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  orders: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MY_ORDERS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case MY_ORDERS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };

    case MY_ORDERS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case MY_ORDERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        orders: action.payload,
      };
    }

    case MY_ORDERS_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_MY_ORDERS:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
